/**
 * @file ids.js
 * @location src/utils/ids.js
 * @role 엔티티 ID 생성 단일 진입점 — crypto.randomUUID 기반. 백엔드 연결 시 ID 충돌 회피.
 *
 *  newId(prefix?)  → `${prefix}_${uuid}` (prefix 생략 시 uuid 만)
 *
 *  컨벤션:
 *    task / member / dept / lvl / tmpl / todo / abs / att
 *
 *  기존 데이터 호환: 시스템은 ID 를 opaque string 으로 취급(equality 만 사용).
 *  과거 `'t' + Date.now()` 형식의 ID 도 그대로 매칭됨.
 *  예외 — 변경 금지:
 *    · src/utils/inviteCode.js : 사용자 입력용 4 자리 코드
 */

function uuid() {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}

export function newId(prefix) {
  return prefix ? `${prefix}_${uuid()}` : uuid();
}

/** task.id ('t' + timestamp) 에서 생성 시각 ISO 문자열을 복원. 추정 불가 시 현재 시각. */
export function taskCreatedAtISO(id) {
  const n = Number(String(id ?? '').slice(1));
  if (!Number.isFinite(n) || n <= 0) return new Date().toISOString();
  return new Date(n).toISOString();
}
